<template>
  <div class="HCxF">
    <atomic-search-interface id="searchInterface" class="publication-search" fields-to-include='["organiz122xationz32xname", "organiz122xationz32xtype", "practitionerterritory", "practitionerfulladdress", "city", "country", "territory", "phone", "email", "website", "contactz32xname", "contactz32xtitle", "latitude", "longitude","z122xipz32xcode"]' :search-hub="searchHub">
      <atomic-layout-section section="search">
        <label for="search">Search</label>
        <atomic-search-box></atomic-search-box>
      </atomic-layout-section>
      <PractitionerFacets></PractitionerFacets>
      <div class="row mb-4">
          <div class="col-lg-4">
            <hcxf-practitioner-results />
             <div class="atomic-divider"></div> 
            <coveoPagination></coveoPagination>
        </div>
        <div class="col-lg-8 d-none d-lg-block">
          <atomic-layout-section section="main">
            <hcxf-practitioner-map></hcxf-practitioner-map>
           
          </atomic-layout-section>
        </div>
      </div>
  </atomic-search-interface>
  </div>
</template>
<script>
  import coveoPagination from './atomic-pagination.vue'
  import PractitionerFacets from "./hcxf-practitioner-facets.vue";
  var map;
  var mapMarkers = [];
  var lastResultSet = [];
  const defaultLat = 32.8826285;
  const defaultLng = -96.7662485;

  async function initMap() {
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    map = new Map(document.getElementById("hcxf-map"), {
      center: { lat: defaultLat, lng: defaultLng },
      zoom: 4,
      maxZoom: 12,
      mapId: "practitionerMap"
    })

    google.maps.event.trigger(map, "resize");
  }

  async function addMarker(title, position) {
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const marker = new AdvancedMarkerElement({
      map,
      position: position,
      title: title
    });

    mapMarkers.push(marker);
  }

  function setMapOnAll(map) {
    mapMarkers.forEach(marker => {
      marker.setMap(map);
    });
  }

  async function deleteMarker(marker) {
    marker.setMap(null);
    mapMarkers.splice(mapMarkers.findIndex(m => m.position === marker.position), 1);
  }

  function deleteMarkers() {
    setMapOnAll(null);
    mapMarkers = [];
  }

  async function showMarkers() {
    setMapOnAll(map);
  }

  function checkMarkerIfAlreadyExist(lat, lng) {
    return mapMarkers.some(marker => 
      marker.position.lat === lat && marker.position.lng === lng
    );
  }

  async function onSearchResultsUpdated(response) {
  deleteMarkers();

  const bounds = new google.maps.LatLngBounds();
  const results = response.body.results;

  if (results.length === 0) {
    centerMapOnPoint(defaultLat, defaultLng);
    map.setZoom(4);
    return response;
  }

  const geocoder = new google.maps.Geocoder();

  for (const result of results) {
    let latitude = parseFloat(result.raw.latitude);
    let longitude = parseFloat(result.raw.longitude);
    const title = result.title;

    if (latitude && longitude) {
      const isExist = checkMarkerIfAlreadyExist(latitude, longitude);
      if (!isExist) {
        await addMarker(title, { lat: latitude, lng: longitude });
      }
      bounds.extend({ lat: latitude, lng: longitude });
    } else {
      const geocodeResult = await new Promise((resolve, reject) => {
        geocoder.geocode({ address: result.raw.z122xipz32xcode }, (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;
            resolve({ lat: location.lat(), lng: location.lng() });
          } else {
            console.error("Geocode Failed:", status);
            reject(status);
          }
        });
      });

      if (geocodeResult) {
        latitude = geocodeResult.lat;
        longitude = geocodeResult.lng;
        const isExist = checkMarkerIfAlreadyExist(latitude, longitude);
        if (!isExist) {
          await addMarker(title, { lat: latitude, lng: longitude });
        }
        bounds.extend({ lat: latitude, lng: longitude });

        result.raw.latitude = latitude;
        result.raw.longitude = longitude;
      }
    }
  }

  await showMarkers();
  lastResultSet = results;

  if (results.length === 1) {
    const singleResult = results[0];
    centerMapOnPoint(parseFloat(singleResult.raw.latitude), parseFloat(singleResult.raw.longitude));
    map.fitBounds(bounds);
    map.setZoom(8);
  } else {
    map.fitBounds(bounds);
  }
  return response;
}

  async function centerMapOnPoint(lat, lng) {
    map.setCenter({ lat: lat, lng: lng });
  }

  function getAllOrgCards() {
    const resultList = document.querySelector("atomic-result-list").shadowRoot.querySelector("div.list-root");
    if (!resultList) {
      console.error("No atomic-result-list found.");
      return [];
    }
    const orgCards = [];
    resultList.childNodes.forEach((result) => {
      if(result.tagName === 'ATOMIC-RESULT') {
        const shadowRoot = result.shadowRoot;
        if (shadowRoot) {
          const orgCard = shadowRoot.querySelector('.organization-card');
          if (orgCard) {
            orgCards.push(orgCard);
          }
        }
      }
    });
    return orgCards;
  }

  async function registerLinkEvents() {
    var shadowRoot = document.querySelector("atomic-result-list").shadowRoot;
    if (shadowRoot) {
      var links = shadowRoot.querySelector("div.list-root");
      if (links) {
        links.childNodes.forEach(function (node, index) {
          if (node.tagName === "ATOMIC-RESULT") {
            var atomicResultShadowRoot = node.shadowRoot;
            var resultRoot = atomicResultShadowRoot.querySelector("div.result-root atomic-result-fields-list");
            if (resultRoot) {
              resultRoot.childNodes.forEach(function (child, index) {
                const childrenNodes = Array.from(child.childNodes)
                childrenNodes.forEach(function (node, i) {
                  if (node.tagName === "ATOMIC-RESULT-SECTION-TITLE") {
                  var resultLink = node.querySelector("atomic-result-link");
                  var unique = node.querySelector("atomic-result-text[field='uniqueId']");
                  var link = resultLink.querySelector("a");

                  if (link && unique) {
                    link.dataset.uniqueId = unique.innerHTML.trim();
                    link.onclick = (event) => {
                      event.preventDefault();
                      var target = event.target.parentElement;

                      if (target) {
                        var uniqueId = target.dataset.uniqueId;
                        var dataItem = lastResultSet.find((element) => element.uniqueId === uniqueId);

                        if (dataItem) {
                          var latitude = dataItem.raw.latitude;
                          var longitude = dataItem.raw.longitude;
                          centerMapOnPoint(latitude, longitude);
                          map.setZoom(6);
                          const cards = getAllOrgCards();
                          if (cards) {
                            const activeCardClass = 'active-card';
                            cards.forEach(card => card.classList.remove(activeCardClass));
                            const card = link.closest('.organization-card');
                            card.classList.add(activeCardClass);
                          }
                        }
                      }
                    }
                  }
                }
                })
              });
            }
          }
        });
      }
    }
  }

  const waitForShadowElement = (selector, part, callback, retryCount = 10) => {
    const element = document.querySelector(selector);
        if (element) {
            const shadowRoot = element.shadowRoot;
            if (shadowRoot) {
                const target = shadowRoot.querySelector(`[part="${part}"]`);
                if (target) {
                    callback(target);
                    return;
                }
            }
        }
        if (retryCount > 0) {
            setTimeout(() => waitForShadowElement(selector, part, callback, retryCount - 1), 1000);
        } else {
          console.error('Could not find the Shadow DOM element.');
      }
  };



  export default {
    props: {
      accessToken: {
        type: String,
        required: true,
      },
      organizationId: {
        type: String,
        required: true,
      },
        searchHub: {
        type: String,
        required: true,
      },
      indexName: {
          type: String,
          required: true,
      },
      templateId: {
          type: String,
          required: true,
      },
    },
    mounted() {
      this.initInterface();
    },

    components: {
      PractitionerFacets,
        coveoPagination: coveoPagination
    },
    methods: {
      async initInterface() {
        await this.$nextTick();
        initMap();

        await customElements.whenDefined('atomic-search-interface');
        const searchInterface = document.querySelector('atomic-search-interface');

        waitForShadowElement(
            'atomic-result-list',
            'result-list',
            (resultList) => {
                const style = document.createElement('style');
                style.textContent = `
                    ::-webkit-scrollbar {
                        width: 8px;
                    }
                    ::-webkit-scrollbar-track {
                        background: #e5e5e5;
                        border-radius: 4px;
                    }
                    ::-webkit-scrollbar-thumb {
                        background-color: #002f6c;
                        border-radius: 4px;
                    }
                    ::-webkit-scrollbar-thumb:hover {
                        background-color: #001d42;
                    }
                `;
                resultList.appendChild(style);
            }
        );
        // Initialization
        await searchInterface.initialize({
          accessToken: this.accessToken,
          organizationId: this.organizationId,
          organizationEndpoints: await searchInterface.getOrganizationEndpoints(this.organizationId),
          search: {
            preprocessSearchResponseMiddleware: onSearchResultsUpdated
          },
           preprocessRequest: (request, clientOrigin, metadata) => {
            const body = JSON.parse(request.body);
            if (clientOrigin === 'searchApiFetch') {
                body.aq ='(@source==(\"' + this.indexName + '\") ( @z95xtemplate=' + this.templateId + '))';
                body.searchHub = this.searchHub;
            }
            
            request.body = JSON.stringify(body);
            return request;
            },
        });

        var engine = searchInterface.engine;

        engine.subscribe(() => {
          registerLinkEvents();
          const searchBox = document.querySelector('atomic-search-box').shadowRoot;
          if(searchBox.children[0] && searchBox.children[0].firstElementChild) {
              const div = searchBox.children[0].firstElementChild
              if (div) {
                div.classList.add("w-full")
              }                    
          }
        });

          // Trigger a first search
        await searchInterface.executeFirstSearch();
      }
    }
  }
</script>

<style lang="scss" scoped>

  label[for='search'] {
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/app/components/hcxf/hcxf-practitioner-hub.vue